import { useState, useEffect } from 'react';
import cryptoWalesLogo from '../assets/images/cryptowales.png'  // Add this at the top


const BitcoinScreensaver = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [direction, setDirection] = useState({ dx: 2, dy: 2 });
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });
  
  const logoSize = { width: 50, height: 50 };
  
  useEffect(() => {
    const container = document.getElementById('screensaver-container');
    if (container) {
      setContainerSize({
        width: container.clientWidth,
        height: container.clientHeight
      });
    }

    const handleResize = () => {
      if (container) {
        setContainerSize({
          width: container.clientWidth,
          height: container.clientHeight
        });
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const moveFrame = () => {
      setPosition(prev => {
        const nextX = prev.x + direction.dx;
        const nextY = prev.y + direction.dy;
        
        let newDx = direction.dx;
        let newDy = direction.dy;

        if (nextX <= 0 || nextX + logoSize.width >= containerSize.width) {
          newDx = -direction.dx;
        }
        if (nextY <= 0 || nextY + logoSize.height >= containerSize.height) {
          newDy = -direction.dy;
        }

        if (newDx !== direction.dx || newDy !== direction.dy) {
          setDirection({ dx: newDx, dy: newDy });
        }

        return {
          x: Math.max(0, Math.min(nextX, containerSize.width - logoSize.width)),
          y: Math.max(0, Math.min(nextY, containerSize.height - logoSize.height))
        };
      });
    };

    const animationId = requestAnimationFrame(moveFrame);
    return () => cancelAnimationFrame(animationId);
  }, [position, direction, containerSize]);


  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center p-4">
      <div className="text-center mb-20">
        <img src={cryptoWalesLogo} className="w-[700px] h-auto mb-0"  alt="cryptowales logo"/>
        <p className="text-xl text-gray-300">A Crypto Community based in Cardiff South Wales</p>
        <br></br>
        <p className="text-xl text-gray-300">Website coming soon</p>
      </div>
      <div id="screensaver-container" className="w-full max-w-4xl h-96 bg-gray-800 relative overflow-hidden border border-gray-700 rounded-lg">
        <div 
          className="absolute"
          style={{
            transform: `translate(${position.x}px, ${position.y}px)`,
          }}
        >
          <svg
            width={logoSize.width}
            height={logoSize.height}
            viewBox="0 0 32 32"
            fill="#F7931A"
          >
            <path d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm7.189-17.98c.314-2.096-1.283-3.223-3.465-3.975l.708-2.84-1.728-.43-.69 2.765c-.454-.114-.92-.22-1.385-.326l.695-2.783L15.596 6l-.708 2.839c-.376-.086-.746-.17-1.104-.26l.002-.009-2.384-.595-.46 1.846s1.283.294 1.256.312c.7.175.826.638.805 1.006l-.806 3.235c.048.012.11.03.18.057l-.183-.045-1.13 4.532c-.086.212-.303.531-.793.41.018.025-1.256-.313-1.256-.313l-.858 1.978 2.25.561c.418.105.828.215 1.231.318l-.715 2.872 1.727.43.708-2.84c.472.127.93.245 1.378.357l-.706 2.828 1.728.43.715-2.866c2.948.558 5.164.333 6.097-2.333.752-2.146-.037-3.385-1.588-4.192 1.13-.26 1.98-1.003 2.207-2.538zm-3.95 5.538c-.533 2.147-4.148.986-5.32.695l.95-3.805c1.172.293 4.929.872 4.37 3.11zm.535-5.569c-.487 1.953-3.495.96-4.47.717l.86-3.45c.975.243 4.118.696 3.61 2.733z"/>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default BitcoinScreensaver;